module.exports = __webpack_public_path__ + "img/page.d52b094e.png";